import {Container} from '../../components/Container';
import {Row} from '../../components/Row';
import React, {memo, ReactNode, useCallback} from 'react';
import {Button} from '../../components/Button';
import {Column} from '../../components/Column';
import {Widget} from '../../components/Widget';
import {
    backButtonToggle, groupSettingAction,
    setMediaScreenAction, setSTPUIMediaScreenAction,
} from '../../store/ui/actions';

import mediaCreateIcon from '../../assets/images/icons/media/create-media.png';
import iconAirConditioner from '../../assets/images/icons/media/air-conditioner.png';
import iconMusicPlayer from '../../assets/images/icons/media/music-player.png';
import iconTV from '../../assets/images/icons/media/tv.png';
import iconSatellite from '../../assets/images/icons/media/satellite.png';
import iconProjection from '../../assets/images/icons/media/projection.png';
import iconOther from '../../assets/images/icons/media/other.png';

import {MediaModel} from '../../types/control';
import {useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {useFilterSelector} from '../../hooks/filter-selector';
import {STPUIEntity} from '../../store/control/state';
import {useLocalization} from "../../hooks/localization";

export const mediaIcons = {
    'create': mediaCreateIcon,
    'tv': iconTV,
    'air-conditioner': iconAirConditioner,
    'music-player': iconMusicPlayer,
    'satellite': iconSatellite,
    'projection': iconProjection,
    'other': iconOther,
};

const MyButton = memo(function MyButton({
                                            typeId,
                                            media,
                                            title,
                                            onClick,
                                            children,
                                        }: { media?: MediaModel | STPUIEntity, typeId: string, title: string, onClick: (media?: MediaModel | STPUIEntity) => void, children?: ReactNode }) {
    return (
        <Column min={3} max={6}>
            <Widget style={{padding: 0}}>
                <Button icon={mediaIcons[typeId]} title={title} onClick={() => onClick(media)}>
                    {children}
                </Button>
            </Widget>
        </Column>
    );
});

export const MediaListScreen = memo(function MediaListScreen() {
    const {t} = useLocalization();
    const history = useHistory();
    const mediaList = useSelector(state => state.control.mediaList);
    const stpUIMediaList = useFilterSelector(state => state.control.stpUIList, (u) => u.type === 'media' || u.type === 'air');
    const dispatch = useDispatch();
    dispatch(backButtonToggle({is_open: true, to: '/'}));
    dispatch(groupSettingAction({visible: false}));
    const onCreatePress = useCallback(() => history.push('/media-remote/create'), [history]);
    const onControlPress = useCallback((media: MediaModel) => dispatch(setMediaScreenAction(media)), [dispatch]);
    const onSTPUIMediaPress = useCallback((media: STPUIEntity) => dispatch(setSTPUIMediaScreenAction(media)), [dispatch]);

    return (
        <Container>
            <div className='page-wrapper'>
                <Row>
                    <MyButton typeId={'create'} title={t('ADD_REMOTE')}
                              onClick={onCreatePress}/>
                    {
                        mediaList.map(media => (
                            <MyButton
                                media={media}
                                key={`control_${media.id}`}
                                typeId={media.icon}
                                title={media.name}
                                onClick={onControlPress}/>
                        ))
                    }
                </Row>
                <Row style={{marginTop: 119}}>
                    {
                        stpUIMediaList.map(stpUIMedia => (
                            <MyButton
                                media={stpUIMedia}
                                key={`stpUIMedia_${stpUIMedia.id}`}
                                typeId={mediaList.find(m => m.id === stpUIMedia.relational_id)?.icon || 'create'}
                                title={stpUIMedia.display_name}
                                onClick={onSTPUIMediaPress}/>
                        ))
                    }
                </Row>
            </div>
        </Container>
    );
});
